import useUser from "@hooks/useUser"

import { Hint } from "@atoms/index"

import { useNotificationMethodsQuery } from "@pages/Settings/SettingsNotifications/components/NotificationMethodsSection/NotificationMethodsSection.store"

import { EmailNotificationTooltipProps } from "./EmailNotificationTooltip.types"

export default function EmailNotificationTooltip(props: EmailNotificationTooltipProps) {
    const { children } = props

    // The form library checks all the checkboxes when initial data is loaded, triggering hints.
    const { user } = useUser()

    const { data: defaultMethodsPreference } = useNotificationMethodsQuery()

    const hasVerifiedEmail = user?.email_verified ?? false

    const tooltipTitle = hasVerifiedEmail ? "Notification method is off" : "Email address not verified"
    const tooltipColorScheme = hasVerifiedEmail ? "tomato" : "amber"
    const tooltipMessage = hasVerifiedEmail
        ? "This can't be edited because the related notification method is off. Turn the method on to manage these topics."
        : "Verify your email address to turn on email notifications."

    return (
        <Hint
            colorScheme={tooltipColorScheme}
            title={tooltipTitle}
            body={tooltipMessage}
            isDisabled={hasVerifiedEmail && (defaultMethodsPreference?.contact_email ?? false)}
            defaultPlacement="right"
        >
            {children}
        </Hint>
    )
}
